export enum MimeType {
	None	= 0,
	Jpeg	= 1,
	Png		= 2,
	Pdf		= 3
}
